<template>
  <div
    class="cycle-status-tabs d-flex align-center"
    role="tablist"
    aria-label="Cycle status"
    data-testid="cycles-page__status-tabs"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="cycle-status-tabs__tab"
      :class="{ 'cycle-status-tabs__tab--active': value === tab.key }"
      :aria-selected="value === tab.key"
      :disabled="disabled"
      :data-testid="`cycles-page__status-tab--${tab.key}`"
      @click="onSelect(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
import './CycleStatusTabs.scss';
import { CYCLE_STATUS_TABS } from '../../utils/cyclesConstants';

export default {
  name: 'CycleStatusTabs',

  props: {
    value: {
      type: String,
      default: 'all',
    },
    tabs: {
      type: Array,
      default: () => CYCLE_STATUS_TABS,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onSelect(key) {
      if (this.disabled || key === this.value) return;
      this.$emit('input', key);
    },
  },
};
</script>
